export default defineNuxtPlugin(() => {
	// const { mode } = useRuntimeConfig().public;
	// if (mode === "dev") {
	// 	const script = document.createElement("script");
	// 	script.src = "https://web.cmp.usercentrics.eu/ui/loader.js";
	// 	script.id = "usercentrics-cmp";
	// 	script.setAttribute("data-settings-id", "WGHmydqAuHC06-"); // TODO: add data-settings-id in env
	// 	script.async = true;
	// 	document.head.appendChild(script);
	// }
});
